"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = reactRender;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _callSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/callSuper"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react2 = _interopRequireWildcard(require("react"));
var _client = _interopRequireDefault(require("react-dom/client"));
var _Log = _interopRequireDefault(require("../common/Log"));
var _utils = require("../common/utils");
var _Wapp = require("../common/Wapp");
var Wapplr = /*#__PURE__*/function (_React$Component) {
  function Wapplr(props, context) {
    var _this;
    (0, _classCallCheck2["default"])(this, Wapplr);
    _this = (0, _callSuper2["default"])(this, Wapplr, [props, context]);
    _this.setRef = _this.setRef.bind(_this);
    _this.refElement = null;
    _this.state = {
      Component: props.Component
    };
    return _this;
  }
  (0, _inherits2["default"])(Wapplr, _React$Component);
  return (0, _createClass2["default"])(Wapplr, [{
    key: "setRef",
    value: function setRef(e) {
      this.refElement = e;
    }
  }, {
    key: "renderAgain",
    value: function renderAgain(Component, callback) {
      var res = this.context.res;
      if (Component !== this.state.Component) {
        if (callback) {
          var asyncFunction = /*#__PURE__*/function () {
            var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return t.setState({
                      Component: Component
                    });
                  case 2:
                    callback();
                  case 3:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return function asyncFunction() {
              return _ref.apply(this, arguments);
            };
          }();
          var t = this;
          asyncFunction();
        } else {
          this.setState({
            Component: Component
          });
        }
      } else {
        if (this.refElement && this.refElement.onLocationChange) {
          var onLocationChange = this.refElement.onLocationChange;
          if (callback) {
            var _asyncFunction = /*#__PURE__*/function () {
              var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2() {
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return onLocationChange(res.wappResponse.store.getState("req.url"));
                    case 2:
                      callback();
                    case 3:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              }));
              return function _asyncFunction() {
                return _ref2.apply(this, arguments);
              };
            }();
            _asyncFunction();
          } else {
            onLocationChange(res.wappResponse.store.getState("req.url"));
          }
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.effect) {
        this.props.effect();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.refElement = null;
    }
  }, {
    key: "render",
    value: function render() {
      var Component = this.state.Component ? (0, _Wapp.withWapp)(this.state.Component) : null;
      if (Component) {
        var setRef = this.setRef;
        return /*#__PURE__*/_react2["default"].createElement(Component, {
          wappRef: setRef
        });
      }
      return null;
    }
  }]);
}(_react2["default"].Component);
Wapplr.contextType = _Wapp.WappContext;
function reactRender() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var wapp = p.wapp;
  var middleware = wapp.client.middlewares.render;
  if (!middleware._initializedWapplrReact) {
    var config = wapp.client.config;
    if (!config.styles) {
      config.styles = {};
    }
    if (typeof config.styles.disableClearStyles == "undefined") {
      config.styles.disableClearStyles = true;
    }
    wapp.contents.add({
      log: {
        render: _Log["default"],
        renderType: "react"
      }
    });
    var lastRenderType = null;
    var mutableContext = {
      wapp: wapp,
      req: null,
      res: null
    };
    wapp.styles.use = function (styles) {
      if (mutableContext.res.wappResponse.content && mutableContext.res.wappResponse.content.renderType === "react" || !mutableContext.res.wappResponse.content && lastRenderType === "react") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, _react2.useLayoutEffect)(function () {
          return wapp.styles.add(styles);
        }, [styles]);
        lastRenderType = "react";
      } else {
        lastRenderType = null;
        return wapp.styles.add(styles);
      }
    };
    middleware.addHandle({
      react: function () {
        var _react = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3(req, res, next) {
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                mutableContext.req = req;
                mutableContext.res = res;
                if (!(res.wappResponse.content && res.wappResponse.content.renderType === "react")) {
                  _context3.next = 11;
                  break;
                }
                if (typeof res._originalEndFunction === "undefined") {
                  Object.defineProperty(res, "_originalEndFunction", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
                    writable: false,
                    enumerable: false,
                    value: res.end
                  }));
                }
                res.end = function (Component, callback) {
                  if (!res.wappResponse.sended) {
                    Object.defineProperty(res, "headersSent", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
                      enumerable: false,
                      writable: false,
                      value: true
                    }));
                    var container = res.wappResponse.container;
                    if (!middleware.renderedRef) {
                      if (res.wapplrReactEndType === "component") {
                        var Render = function Render() {
                          (0, _react2.useEffect)(function () {
                            if (callback) {
                              callback();
                            }
                          }, []);
                          return /*#__PURE__*/_react2["default"].createElement(_Wapp.WappContext.Provider, {
                            value: mutableContext
                          }, /*#__PURE__*/_react2["default"].createElement(Wapplr, {
                            ref: function ref(e) {
                              middleware.renderedRef = e;
                            },
                            Component: Component
                          }));
                        };
                        if (res._originalEndFunction) {
                          res._originalEndFunction({
                            Render: Render,
                            wapp: wapp,
                            req: req,
                            res: res
                          });
                        }
                        return;
                      }
                      if (container._reactRoot) {
                        container._reactRoot.render( /*#__PURE__*/_react2["default"].createElement(_Wapp.WappContext.Provider, {
                          value: mutableContext
                        }, /*#__PURE__*/_react2["default"].createElement(Wapplr, {
                          key: Date.now(),
                          ref: function ref(e) {
                            middleware.renderedRef = e;
                          },
                          Component: Component,
                          effect: function effect() {
                            if (callback) {
                              callback();
                            }
                          }
                        })));
                      } else {
                        container._reactRoot = _client["default"].hydrateRoot(container, /*#__PURE__*/_react2["default"].createElement(_Wapp.WappContext.Provider, {
                          value: mutableContext
                        }, /*#__PURE__*/_react2["default"].createElement(Wapplr, {
                          key: Date.now(),
                          ref: function ref(e) {
                            middleware.renderedRef = e;
                          },
                          Component: Component,
                          effect: function effect() {
                            if (callback) {
                              callback();
                            }
                          }
                        })));
                      }
                    } else {
                      if (res.wapplrReactEndType === "component") {
                        if (res._originalEndFunction) {
                          res._originalEndFunction({
                            update: function update() {
                              return middleware.renderedRef.renderAgain(Component, callback);
                            },
                            wapp: wapp,
                            req: req,
                            res: res
                          });
                        }
                        return;
                      }
                      middleware.renderedRef.renderAgain(Component, callback);
                    }
                  }
                };
                res.wappResponse.status(res.wappResponse.statusCode || 200);
                _context3.next = 8;
                return new Promise(function (resolve) {
                  res.wappResponse.send(res.wappResponse.content.render, resolve);
                });
              case 8:
                next();
                _context3.next = 14;
                break;
              case 11:
                middleware.renderedRef = null;
                res.end = res._originalEndFunction ? res._originalEndFunction : res.end;
                next();
              case 14:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        function react(_x, _x2, _x3) {
          return _react.apply(this, arguments);
        }
        return react;
      }()
    });
    Object.defineProperty(middleware, "_initializedWapplrReact", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      writable: false,
      enumerable: false,
      value: true
    }));
    Object.defineProperty(middleware, "wapp", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      writable: false,
      enumerable: false,
      value: wapp
    }));
  }
  return middleware;
}